//
import { PropTypes } from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import parse from 'html-react-parser';


import htmlParserTransform from '../../helpers/htmlParserTransform';

import Redirect from '../common/Redirect';
import Notification from '../common/notification/Notification';
import Personalization from '../common/personalization/Personalization';
import LoadingSpinner from '../common/spinner/LoadingSpinner';

import MsgAPI from '../../api/msg/MsgAPI';
import PersonalizationAPI from '../../api/personalization/PersonalizationAPI';

import FrontendException from '../../models/FrontendException';

import withResizeObserver from '../../hoc/withResizeObserver';

class ConfirmOptoutMsg extends React.Component {
  constructor() {
    super();
    //
    this.mounted = false;
    this.notificationRef = React.createRef();
    this.subscribed = false;
    this.email = '';
    this.description = "";
    this.btnText = "";

    //
    this.state = {
      loading: false,
      showMainContent: false
    };
  }

  componentDidMount() {
    this.mounted = true;
    const params = this.props.match.params;
    //
    if (!this.isUserParamsValid()) {
      //  do not use setState directly in componentDidMount
      this.handleError("Load.Msg.ErrorUserParams");
    } else {
      Promise.all([
        this.getSubscriberEmail(),
        this.isOptin(),
        this.getListSettings()
      ]).then(() => {
        if (this.mounted) {
          this.setState({
            showMainContent: true
          });
        }
      }).catch((error) => {
        this.handleError(error, "default", true);
      })
        .finally(this.stopLoader);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  isTrue(paramValue) {
    return ((paramValue == "true") || (paramValue == "1") || (paramValue == "on"));
  }

  isString(param) {
    return (typeof param === "string") || (param instanceof String);
  }

  /**
   * Verifica parametri idList, idUser, hash, idNL
   * se vuoti/nulli ritorna false
   */
  isUserParamsValid() {
    const params = this.props.match.params;
    const preview = this.isTrue(params.preview);
    const idUser = parseInt(params.idUser, 10);
    const idNL = parseInt(params.idNL, 10);
    //
    //  combinazioni accettate:
    //  preview:1 - idUser:empty - hash:empty - idNL:empty
    //  preview:0 - idUser:valorizzato - hash:valorizzato - idNL:valorizzato
    return Boolean(params.idList && ((!preview && idUser && params.hash && idNL) || preview));
  }

  handleError = (error, source = "default", fatal = false) => {
    //  console.log("PreferenceCenter handleError", error);
    let errorLabel = "Load.Common.Error";
    if (error instanceof FrontendException) {
      errorLabel = error.label;
    } else if (this.isString(error)) {
      errorLabel = error;
    }
    //
    this.notificationRef.current.addError(this.props.intl.formatMessage({ id: errorLabel, defaultMessage: errorLabel }), source, false, !fatal);
  }

  startLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: true
      });
    }
  }

  stopLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: false
      });
    }
  }

  getSubscriberEmail() {
    const params = this.props.match.params;
    let idUser = parseInt(params.idUser, 10);
    if (!idUser) {
      idUser = 0;
    }
    let hash = params.hash;
    if (!hash) {
      hash = '';
    }
    return MsgAPI.getSubscriberEmail(idUser, hash).then((email) => {
      this.email = email;
    });
  }

  getListSettings() {
    const params = this.props.match.params;
    return PersonalizationAPI.getListSettings(parseInt(params.idList)).then((resp) => {
      const obj = JSON.parse(resp.Style);

      if (obj.Message && obj.Message.BtnText) {
        this.btnText = obj.Message.BtnText;
      }

      if (obj.Message && obj.Message.Text) {
        this.description = obj.Message.Text;
      }
    });
  }

  isOptin() {
    const params = this.props.match.params;
    let idUser = parseInt(params.idUser, 10);
    if (!idUser) {
      idUser = 0;
    }
    let hash = params.hash;
    if (!hash) {
      hash = '';
    }
    return MsgAPI.isOptin(params.idList, idUser, hash).then((isOptin) => {
      this.subscribed = isOptin;
    });
  }

  render() {
    //
    const params = this.props.match.params;
    let optoutUrl = "#";
    const preview = this.isTrue(params.preview);
    if (!preview) {
      optoutUrl = "/frontend/doubleoptout.aspx?id=" + encodeURIComponent(params.idUser) + "&idList=" + encodeURIComponent(params.idList) + "&idNL=" + encodeURIComponent(params.idNL) + "&HASH=" + encodeURIComponent(params.hash);
    }
    //
    let unsubscribedMsgUrl = '';
    if (this.email) {
      unsubscribedMsgUrl = '/frontend/unsubscriptionmsg/0/' + encodeURIComponent(params.idList) + '/11/?email=' + encodeURIComponent(this.email);
    } else {
      unsubscribedMsgUrl = '/frontend/unsubscriptionmsg/0/' + encodeURIComponent(params.idList) + '/20/?email=' + encodeURIComponent(this.email);
    }
    //

    const wrapperClassName = preview ? 'frontend-wrapper frontend-wrapper--preview' : 'frontend-wrapper';

    return (
      <div>
        <Notification ref={this.notificationRef} />
        {this.state.loading && <LoadingSpinner />}

        {this.state.showMainContent &&
          <React.Fragment>
            {!preview && !this.subscribed &&
              <Redirect to={unsubscribedMsgUrl} />
            }

            {(preview || this.subscribed) &&
              <div className={wrapperClassName}>
                <Personalization idList={this.props.match.params.idList} showLogo applyCustomCSS />
                <div className="frontend-box">

                  <div className="frontend-row">
                    <h2>
                      {this.description
                        ? parse(this.description, { replace: htmlParserTransform })
                        : <FormattedMessage id="Load.ConfirmOptout.TextIntro" />}
                    </h2>
                  </div>

                  <div className="frontend-row">
                    <form action='/frontend/doubleoptout.aspx' method='post'>
                      <input type='hidden' name='id' value={params.idUser} />
                      <input type='hidden' name='idList' value={params.idList} />
                      <input type='hidden' name='idNL' value={params.idNL} />
                      <input type='hidden' name='HASH' value={params.hash} />

                      <button type='submit' className="frontend_main-button" disabled={preview}>
                        {this.btnText
                          ? parse(this.btnText, { replace: htmlParserTransform })
                          : <FormattedMessage id="Load.ConfirmOptout.ButtonLabel" />}
                      </button>
                    </form>
                  </div>

                </div>
              </div>
            }
          </React.Fragment>
        }
      </div>
    );
  }
}

ConfirmOptoutMsg.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      preview: PropTypes.string.isRequired,
      idList: PropTypes.string.isRequired,
      idUser: PropTypes.string,
      hash: PropTypes.string,
      idNL: PropTypes.string
    })
  }),

};

export default withResizeObserver(injectIntl(ConfirmOptoutMsg), 'ConfirmOptoutMsg');